export default function createPageTitle(title: string) {
  return title + ' | Ecruu';
}
